/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.flexbox-for-WarningImage[_ngcontent-%COMP%]\r\n{\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    gap: 90px;\r\n}\r\n.flexconatiner-for-Image[_ngcontent-%COMP%]\r\n{\r\n    height: 115px;\r\n    width: 300px;\r\n}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvU0hSNk0zL0RldmVsb3BtZW50L1BhY2tJVFdlYkd1aS9zcmMvYXBwL2ltYWdlLXdhcm5pbmctYmVmb3JlLXVwbG9hZC9pbWFnZS13YXJuaW5nLWJlZm9yZS11cGxvYWQuY29tcG9uZW50LmNzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9DOi9Vc2Vycy9TSFI2TTMvRGV2ZWxvcG1lbnQvUGFja0lUV2ViR3VpL3NyYy9hcHAvaW1hZ2Utd2FybmluZy1iZWZvcmUtdXBsb2FkL2ltYWdlLXdhcm5pbmctYmVmb3JlLXVwbG9hZC5jb21wb25lbnQuY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/$$_gendir/app/image-warning-before-upload/image-warning-before-upload.component.css.shim.ngstyle.ts